module.exports = __webpack_public_path__ + "static/media/6793883d4f521e8b9bfa7d2a_stripes-hor-on-dark.281fc7dd.jpg";